export default __webpack_public_path__ + "static/media/gallery_05.9e213b9e.jpg";